module.exports = __webpack_public_path__ + "media/components/signup/static/surf_image_2-49aa87751db4a5782399d136afd8b405.jpg";